import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {PlayerAssessmentResponse} from './types';

// GET /players/<username>/assessment/ -- IsAuthenticated + owner-only.
export const useGetPlayerAssessmentApi = (username?: string) =>
  useQuery(
    ['playerAssessment', username],
    async (): Promise<PlayerAssessmentResponse> =>
      (await ChessRestClient.get(`/players/${username}/assessment/`)).data,
    {enabled: !!username},
  );

export default useGetPlayerAssessmentApi;
